module.exports = __webpack_public_path__ + "img/FOAMING_MACHINE.6a8c7616.jpg";